import { render, staticRenderFns } from "./DeleteButton.vue?vue&type=template&id=12685a6d&"
import script from "./DeleteButton.vue?vue&type=script&lang=js&"
export * from "./DeleteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/marcosalazar/Documents/HM/Timelapse/timelapse-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12685a6d')) {
      api.createRecord('12685a6d', component.options)
    } else {
      api.reload('12685a6d', component.options)
    }
    module.hot.accept("./DeleteButton.vue?vue&type=template&id=12685a6d&", function () {
      api.rerender('12685a6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DeleteButton.vue"
export default component.exports